import type { TrpcRouter } from '@rolebase/backend'
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { getValidAccessToken } from './authToken'
import settings from './settings'

export const trpc = createTRPCClient<TrpcRouter>({
  links: [
    httpBatchLink({
      url: settings.backendUrl,
      // Auth with Nhost. Refresh the token before each request (and sign out on
      // a stale session) via the shared helper, so a dead session redirects to
      // login here just like it does for Apollo. See authToken.ts.
      headers: async () => {
        const token = await getValidAccessToken()
        return token ? { Authorization: `Bearer ${token}` } : {}
      },
    }),
  ],
})
